/*
 * נומה — מקור ההוספה לסל + כרית Snow Cool במחיר מיוחד (אורי 12/10/2026).
 *
 * 1. כל הוספה לסל מקבלת מאפיין שורה נסתר _added_from (שופיפיי מסתיר מאפיינים
 *    שמתחילים ב-_ בסל ובקופה; הם עוברים להזמנה → n8n → אודו). אותו ערך נשלח
 *    ל-GA4 כפרמטר added_from על אירוע add_to_cart של אפליקציית גוגל (gtag 'set').
 *    מפתחות:
 *      pdp_main             כפתור הקנייה בעמוד המוצר
 *      pdp_sticky           הכפתור הדביק במובייל (מפעיל את כפתור העמוד)
 *      pdp_addon            "+" בקרוסלת "מומלץ להשלים" בעמוד מוצר
 *      cart_upsell          "+" בקרוסלת "מומלץ להשלים" בעמוד הסל
 *      pillow_bundle        הצעת הכרית (ועוד _added_from_page: buybox / product / drawer / cart)
 *      drop_card            כפתור בכרטיס "דרופ השבוע"
 *      collection_card      כפתור בכרטיס בעמוד קולקציה (numa-collection-grid)
 *      card_quick_add       הוספה מהירה מכרטיס מוצר רגיל
 *      quick_shop           חלון "קנייה מהירה"
 *      cart_recommendations "You may also like" במגירה/בסל
 *      other                כל טופס הוספה אחר
 *    טופס שכבר נושא properties[_added_from] (numa-upsell, numa-drop, numa-collection-grid)
 *    נשאר עם הערך שלו.
 * 2. בחירת כרית בטופס הקנייה (snippets/numa-pillow-offer, page: buybox): אחרי שהמוצר
 *    נכנס לסל, הכרית/הזוג נוספים מיד — לחיצה אחת. הקנייה עצמה לא משתנה.
 * 3. כרטיס הכרית במגירה ובסל: מוצג במחיר המיוחד כשיש בסל מזרן/ספה/מיטה.
 */
import Cart from "cart-store";

(function () {
  if (window.numaAddedFrom) return;

  var STICKY_WINDOW_MS = 2500;
  var GA_RESET_MS = 6000;
  var lastSticky = 0;
  var gaTimer = null;
  var pendingPillow = null;

  function gaSource(src) {
    try {
      if (typeof window.gtag !== 'function') return;
      window.gtag('set', { added_from: src });
      clearTimeout(gaTimer);
      gaTimer = setTimeout(function () {
        try { window.gtag('set', { added_from: null }); } catch (e) {}
      }, GA_RESET_MS);
    } catch (e) {}
  }
  window.numaAddedFrom = { mark: gaSource };

  function detect(form) {
    if (Date.now() - lastSticky < STICKY_WINDOW_MS && form.closest('product-form.v2-form, .v2-form')) return 'pdp_sticky';
    if (form.closest('quick-shop, .quick-shop')) return 'quick_shop';
    if (form.closest('cart-recommendations, [id*="cart-recommendations"]')) return 'cart_recommendations';
    if (form.closest('.numa-upsell')) return /\/cart\/?$/.test(location.pathname) ? 'cart_upsell' : 'pdp_addon';
    if (form.closest('product-card, product-card-mini, .product-card, .product-card-mini, .card')) return 'card_quick_add';
    if (form.classList.contains('v2-form__inner') || form.closest('product-form.v2-form, .js-product-form, .product-form--single')
        || form.classList.contains('js-product-form') || form.classList.contains('product-form--single')) return 'pdp_main';
    return 'other';
  }

  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/.test(action) && !!form.querySelector('[name="id"]');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#MobileDualCart, .mobile-sticky-cta__button--cart')) lastSticky = Date.now();
  }, true);

  // capture: רץ לפני product-form.js שקורא את FormData של הטופס
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form)) return;
    try {
      var input = form.querySelector('input[name="properties[_added_from]"]');
      var src = input && input.value;
      if (!src) {
        src = detect(form);
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_added_from]';
        input.value = src;
        form.appendChild(input);
      }
      gaSource(src);

      var box = (form.closest('.v2-info, .v2-form, section') || document).querySelector('[data-numa-pillow-buybox]')
        || form.querySelector('[data-numa-pillow-buybox]');
      if (box) {
        var picked = box.querySelector('input[name="numa_pillow"]:checked');
        var qty = picked ? Number(picked.value) : 0;
        var mainId = form.querySelector('[name="id"]');
        pendingPillow = qty > 0 && mainId ? {
          mainId: Number(mainId.value), qty: qty, variant: Number(box.dataset.variant), at: Date.now()
        } : null;
      }
    } catch (err) {
      // תיוג לא מפיל הוספה לסל
    }
  }, true);

  document.addEventListener('on:cart:loaded', function (e) {
    var d = e.detail || {};
    if (d.type !== 'ADD' || !pendingPillow) return;
    var p = pendingPillow;
    if (Date.now() - p.at > 20000) { pendingPillow = null; return; }
    var ids = (d.items || []).map(function (i) { return Number(i.id); });
    if (ids.indexOf(p.mainId) === -1) return;
    pendingPillow = null;
    // אחרי שהחנות של התבנית סיימה את ההוספה הראשונה (באותו tick היא עוד "באמצע")
    setTimeout(function () {
      gaSource('pillow_bundle');
      Promise.resolve(Cart).then(function (Store) {
        return Store.add({ id: p.variant, quantity: p.qty,
          'properties[_added_from]': 'pillow_bundle', 'properties[_added_from_page]': 'buybox' });
      }).catch(function (err) { if (window.console) console.warn('numa pillow add failed', err); });
    }, 400);
  });

  // בחירת הכרית: לחיצה חוזרת על כרית/זוג שכבר נבחרו מבטלת את הבחירה (אין אפשרות "בלי", אורי 12/10)
  var pillowWasChecked = null;
  document.addEventListener('pointerdown', function (e) {
    var opt = e.target.closest && e.target.closest('.numa-pillow-buybox__opt');
    var input = opt && opt.querySelector('input[name="numa_pillow"]');
    pillowWasChecked = input && input.checked && input.value !== '0' ? input : null;
  }, true);
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.numa-pillow-buybox__opt');
    if (!opt || !pillowWasChecked || !opt.contains(pillowWasChecked)) return;
    var was = pillowWasChecked;
    pillowWasChecked = null;
    e.preventDefault();
    was.checked = false;
  });

  /* ---------- כרטיס הכרית במגירה / בסל / בקרוסלה ---------- */
  var tagCache = {};
  function tagsOf(handle) {
    if (!tagCache[handle]) {
      tagCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
        .then(function (p) { return p.tags || []; })
        .catch(function () { return []; });
    }
    return tagCache[handle];
  }
  // מזכה = סוג מוצר MAT/BED/SOFA/BEA, ואם אין סוג — תגית (3 מזרנים בלי סוג, 12/10)
  function cartQualifies(cart, types) {
    var items = (cart && cart.items) || [];
    if (items.some(function (i) { return types.indexOf(String(i.product_type || '').trim()) !== -1; })) return Promise.resolve(true);
    return Promise.all(items.map(function (i) { return tagsOf(i.handle); })).then(function (all) {
      return all.some(function (tags) { return tags.some(function (t) { return types.indexOf(t) !== -1; }); });
    });
  }
  function nounOf(cart) {
    var types = ((cart && cart.items) || []).map(function (i) { return i.product_type; });
    if (types.indexOf('BED') !== -1) return 'מיטה';
    if (types.indexOf('SOFA') !== -1 || types.indexOf('BEA') !== -1) return 'ספה';
    return 'מזרן';
  }
  // המזרן הראשון בסל (סוג MAT, או תגית MAT למזרנים בלי סוג) → {w, l} מתוך "140x190 / כמו חדש"
  function mattressOf(cart) {
    var items = (cart && cart.items) || [];
    return Promise.all(items.map(function (i) {
      if (String(i.product_type || '').trim() === 'MAT') return Promise.resolve(true);
      if (i.product_type) return Promise.resolve(false);
      return tagsOf(i.handle).then(function (tags) { return tags.indexOf('MAT') !== -1; });
    })).then(function (flags) {
      for (var k = 0; k < items.length; k++) {
        if (!flags[k]) continue;
        var m = String(items[k].variant_title || '').match(/(\d{2,3})\s*[x×*]\s*(\d{3})/);
        if (m) return { w: m[1], l: m[2] };
      }
      return null;
    });
  }
  // מגן מזרן באותה מידה, רק מה שבמלאי (נבנה ב-Liquid לפי כמות); לא מציעים אם כבר בסל
  function fillProtector(el, cart, mat) {
    var row = el.querySelector('[data-protectors]');
    if (!row) return;
    var list = [];
    try { list = JSON.parse(row.dataset.protectors || '[]'); } catch (e) {}
    var inCart = ((cart && cart.items) || []).map(function (i) { return Number(i.variant_id); });
    var pick = null;
    if (mat) {
      for (var k = 0; k < list.length; k++) {
        var s = String(list[k].size || '');
        if (s.indexOf(mat.w + 'x') === 0 && s.indexOf(mat.l) !== -1 && inCart.indexOf(Number(list[k].id)) === -1) { pick = list[k]; break; }
      }
    }
    row.hidden = !pick;
    if (!pick) return;
    row.dataset.variant = pick.id;
    row.querySelector('[data-prot-name]').textContent = pick.name + ' ' + pick.size;
    var promo = Number(pick.promo || 0);
    var hasPromo = promo > 0 && promo < Number(pick.price);
    row.querySelector('[data-prot-price]').textContent = (hasPromo ? promo : pick.price) + ' ₪';
    var was = row.querySelector('[data-prot-was]');
    if (was) { was.hidden = !hasPromo; was.textContent = pick.price + ' ₪'; }
    var note = row.querySelector('[data-prot-note]');
    if (note) note.hidden = !hasPromo;
    var img = row.querySelector('img');
    if (img && pick.img) { img.src = pick.img; img.alt = pick.name; }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-prot-add]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-protectors]');
    var el = btn.closest('[data-numa-pillow-offer]');
    var err = el && el.querySelector('.numa-pillow-offer__err');
    if (err) err.hidden = true;
    gaSource('cart_upsell');
    btn.disabled = true;
    Promise.resolve(Cart).then(function (Store) {
      return Store.add({ id: Number(row.dataset.variant), quantity: 1,
        'properties[_added_from]': 'cart_upsell', 'properties[_added_from_page]': 'drawer' });
    }).catch(function () { if (err) err.hidden = false; })
      .then(function () { btn.disabled = false; });
  });
  var lastCart = null;
  function refresh(cart) {
    var offers = document.querySelectorAll('[data-numa-pillow-offer][data-page="drawer"], [data-numa-pillow-offer][data-page="cart"]');
    if (!offers.length) return;
    var get = cart ? Promise.resolve(cart) : fetch('/cart.js').then(function (r) { return r.json(); });
    get.then(function (c) {
      lastCart = c;
      offers.forEach(function (el) {
        cartQualifies(c, (el.dataset.types || '').split(',')).then(function (ok) {
          el.dataset.state = ok ? 'qualify' : 'plain';
          if (el.dataset.page === 'drawer') el.hidden = !ok || !(c.items || []).length;
          return mattressOf(c).then(function (mat) {
            var noun = el.querySelector('[data-noun]');
            if (noun) noun.textContent = mat ? 'מזרן' : nounOf(c);
            fillProtector(el, c, ok ? mat : null);
          });
        });
      });
    }).catch(function () {});
  }
  document.addEventListener('on:cart:loaded', function (e) { refresh(e.detail && e.detail.cart); });
  // המגירה משכפלת את התבנית שלה כשהסל מתמלא — כרטיס שנוצר עכשיו מקבל את המצב
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-numa-pillow-offer]') || n.querySelector('[data-numa-pillow-offer]'))) {
            clearTimeout(t);
            t = setTimeout(function () { refresh(lastCart); }, 50);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-numa-pillow-offer] [data-qty]');
    if (!btn) return;
    e.preventDefault();
    var el = btn.closest('[data-numa-pillow-offer]');
    var page = el.dataset.page;
    var err = el.querySelector('.numa-pillow-offer__err');
    if (err) err.hidden = true;
    gaSource('pillow_bundle');
    var buttons = el.querySelectorAll('[data-qty]');
    buttons.forEach(function (b) { b.disabled = true; });
    // מפתחות שטוחים: Cart.add של התבנית ממיר properties[...] לאובייקט
    Promise.resolve(Cart).then(function (Store) {
      return Store.add({ id: Number(el.dataset.variant), quantity: Number(btn.dataset.qty || 1),
        'properties[_added_from]': 'pillow_bundle', 'properties[_added_from_page]': page });
    }).then(function () {
      if (page === 'cart') { window.location.reload(); return; }
      if (page === 'product') {
        var drawer = document.querySelector('.modal--cart');
        if (drawer && !drawer.shown && typeof drawer.open === 'function') drawer.open();
      }
    }).catch(function () {
      if (err) err.hidden = false;
    }).then(function () {
      buttons.forEach(function (b) { b.disabled = false; });
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); });
  else refresh();
})();
